import { getColorByIndex } from '@nx-smartmonkey/ui';
import { Driver } from '../domain/driver/Driver';
import { Vehicle } from '../domain/vehicle/Vehicle';
import { VehicleFlat } from '../domain/vehicle/VehicleFlat';

const getColor = (
  elementData: Driver | Vehicle | VehicleFlat,
  elements: Array<Driver> | Array<Vehicle> | Array<VehicleFlat>
) => {
  let colorFound = getColorByIndex(0);
  if (elementData) {
    if (elementData.color) {
      colorFound = elementData.color.value;
    } else {
      const routeIndex = elements.findIndex((r: any) => r.id === elementData.id);
      colorFound = getColorByIndex(routeIndex);
    }
  }
  return colorFound;
};

export const getRouteColor = (routeData: Driver, planDrivers: Driver[]) => getColor(routeData, planDrivers);

export const getVehicleColor = (vehicleData: Vehicle | VehicleFlat, vehicles: Array<Vehicle> | Array<VehicleFlat>) =>
  getColor(vehicleData, vehicles);
